<template>
  <div class="mt20 flex-box">
    <div class="bj-row flex-box-item" v-for="item in list" :key="item.paymentID">
    <!--   单卡片表格   -->
      <PaymentTable ref="PaymentInfo" :row-data="item"></PaymentTable>
    </div>
  </div>
</template>

<script>
import PaymentTable from './index';
export default {
  components: {
    PaymentTable
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped>
.flex-box {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.flex-box-item {
  flex: 0 1 calc(50% - 8px);
  box-sizing: border-box;
}
.flex-box-item:first-child {
  flex: 1 1 calc(50% - 8px);
}
</style>
